import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import * as styles from '../../styles.css';
var UNDERGROUND_LINE_SHIFT = 4;
export var UndergroundLines = function UndergroundLines(_ref) {
  var lines = _ref.lines,
      isMobile = _ref.isMobile;

  if (!lines.length) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", mergeStyles(styles['lines-container'], isMobile && styles['lines-container--mobile']), lines.map(function (line, index) {
    var zIndex = lines.length;
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: styles['underground-line'],
      style: {
        backgroundColor: "#".concat(line.lineColor),
        left: UNDERGROUND_LINE_SHIFT * index,
        zIndex: zIndex - index
      }
    });
  }));
};